/**
 * 公司管理 web api
 * @author Risin.Xu
 * @create 2021-03-02 19:01:36
 */
import request from "@/utils/request";
import service from "@/utils/service"


/**
 * 查询树
 */
export function listTree(param) {
  return request({
    url: service.tcode + "/base/corp/listTree",
    method: "post",
    data: param
  });
}

/**
 * 查询公司管理列表
 */
export function list(param) {
  return request({
    url: service.tcode + "/base/corp/list",
    method: "post",
    data: param
  });
}

/**
 * 启用
 */
export function unseal(pk) {
  return request({
    url: service.tcode + "/base/corp/unseal/" + pk,
    method: "get"
  });
}

/**
 * 封存
 */
export function seal(pk) {
  return request({
    url: service.tcode + "/base/corp/seal/" + pk,
    method: "get"
  });
}

/**
 * 根据PK查询一个公司管理
 */
export function get(pk) {
  return request({
    url: service.tcode + "/base/corp/get/" + pk,
    method: "get"
  });
}

/**
 * 保存公司管理数据
 */
export function save(data) {
  return request({
    url: service.tcode + "/base/corp/save",
    method: "post",
    data: data
  });
}


/**
 * 根据PK查询一个门店管理
 * @param pks 主键数组
 */
/*export function deleteBatch(pks) {
  return request({
    url: service.tcode +  "/base/corp/deleteBatch",
    method: "post",
    data: pks
  })
}*/
/**
 * 根据PK删除 公司管理
 * @param pk 主键
 */

/*export function delData(pk) {
  return request({
    url: service.tcode +  "/base/corp/delete/" + pk,
    method: "get"
  })
}*/
/**
 * 保存公司管理数据
 */
export function mqtt(data) {
  return request({
    url: service.tcode + "/mqtt/get",
    method: "get",
    data: data
  });
}




// WEBPACK FOOTER //
// ./src/api/base/corp.js